<ng-container *ngFor="let resourceAssignment of resourceAssignments">
    <app-order-rent-resourceAssignment-protocols-view
        [resourceAssignment]="resourceAssignment">
    </app-order-rent-resourceAssignment-protocols-view>
</ng-container>
